export const styles = {
  header: 'tw-flex tw-items-center tw-justify-between',
  title: 'tw-text-sm tw-font-medium tw-text-neutral-700',
  grid: 'tw-grid tw-grid-cols-2 tw-gap-2',
  emptyState: 'tw-text-neutral-500 tw-text-sm',
  container: 'tw-flex tw-flex-col tw-gap-4',
};
